<script lang="ts" setup>
type Props = {
  color?: string;
};

withDefaults(defineProps<Props>(), {
  color: "#000",
});
</script>

<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="30"
    height="31"
    viewBox="0 0 30 31"
    fill="none"
  >
    <rect
      x="29.5"
      y="29.5406"
      width="29"
      height="29"
      rx="14.5"
      transform="rotate(-180 29.5 29.5406)"
      :stroke="color"
    />
    <path
      d="M23.5303 14.5103C23.8232 14.8032 23.8232 15.2781 23.5303 15.571L18.7574 20.344C18.4645 20.6368 17.9896 20.6368 17.6967 20.344C17.4038 20.0511 17.4038 19.5762 17.6967 19.2833L21.9393 15.0407L17.6967 10.798C17.4038 10.5051 17.4038 10.0302 17.6967 9.73735C17.9896 9.44446 18.4645 9.44446 18.7574 9.73735L23.5303 14.5103ZM6.5 15.7907C6.08579 15.7907 5.75 15.4549 5.75 15.0407C5.75 14.6264 6.08579 14.2907 6.5 14.2907L6.5 15.7907ZM23 15.7907L6.5 15.7907L6.5 14.2907L23 14.2907L23 15.7907Z"
      :fill="color"
    />
  </svg>
</template>
